<script setup lang="ts">
const props = defineProps<{
    content: Record<string, string | null>;
}>();

const features = [
    { icon: '/images/landing/icon-brain.svg', key: 'features.item_1' },
    { icon: '/images/landing/icon-ear.svg', key: 'features.item_2' },
    { icon: '/images/landing/icon-sliders.svg', key: 'features.item_3' },
    { icon: '/images/landing/icon-clock.svg', key: 'features.item_4' },
];
</script>

<template>
    <section class="bg-white px-4 py-8 md:px-20 md:py-16">
        <div class="mx-auto flex max-w-[1120px] flex-col gap-8 md:flex-row md:items-start md:justify-between md:gap-[43px]">
            <template v-for="(feature, index) in features" :key="feature.key">
                <div class="flex items-center gap-4 md:w-[221px] md:flex-col md:text-center">
                    <img
                        :src="feature.icon"
                        :alt="props.content[feature.key] ?? ''"
                        class="size-[38px] shrink-0"
                    >
                    <p class="text-base font-medium leading-6 text-primary md:mt-3">
                        {{ props.content[feature.key] }}
                    </p>
                </div>

                <!-- Arrow separator (desktop only) -->
                <div v-if="index < features.length - 1" class="mt-3 hidden shrink-0 md:block">
                    <img
                        src="/images/landing/arrow-right.svg"
                        alt=""
                        class="size-[13px] rotate-90"
                    >
                </div>
            </template>
        </div>
    </section>
</template>
